// extracted by mini-css-extract-plugin
export var blockFooter = "block-module--block-footer--245e0";
export var blockImage = "block-module--block-image--c8cdf";
export var blockImg = "block-module--block-img--8192d";
export var blockItem = "block-module--block-item--78eb8";
export var blockPackageBody = "block-module--block-package-body--49fe1";
export var blockPackageDivider = "block-module--block-package-divider--55582";
export var blockPackageItem = "block-module--block-package-item--4a2d2";
export var blockPackageUsps = "block-module--block-package-usps--83bb2";
export var blockPackagesContainer = "block-module--block-packages-container--513c0";
export var blockTabItem = "block-module--block-tab-item--8a89b";
export var blockTabs = "block-module--block-tabs--bb8dd";
export var blockTabsNav = "block-module--block-tabs-nav--0a440";
export var blockTags = "block-module--block-tags--da64c";
export var blockText = "block-module--block-text--1a5a0";
export var blockTextWrap = "block-module--block-text-wrap--3a505";
export var blockTitle = "block-module--block-title--4e4b4";
export var blocksContainer = "block-module--blocks-container--8a9b4";
export var blocksSection = "block-module--blocks-section--b4d80";